import {Component, NgModule, enableProdMode, OnInit, ViewChild, Input} from '@angular/core';
  import { BrowserModule } from '@angular/platform-browser';
  import { Router, ActivatedRoute } from '@angular/router';
  import { DxPopupModule, DxButtonModule, DxTemplateModule, DxDataGridComponent } from 'devextreme-angular';
  import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
  import ArrayStore from 'devextreme/data/array_store';
  import {ProvisionalmarksheetService, provisionalmarksheet}from './../../services/provisionalmarksheet.service';
  import {
    DxSelectBoxModule,
    DxTextAreaModule,
    DxDateBoxModule,
    DxFormModule
  } from 'devextreme-angular';
  import { Configuration } from '../../../app.constants';
  import {formatDate} from '@angular/common';
  import {HelperService} from '../../../shared/services/helper.service';
  import { DxFormComponent } from 'devextreme-angular';
  import { BranchchangeService,BranchChange } from './../../../changerequest/services/branchchange.service';
  import{PhotocopyService,ResultQueryInfo}from'./../../../revaluation/services/photocopy.service';
  import {CetadmissionService,CETadmission} from './../../../studentportal/services/cetadmission.service';

@Component({
  selector: 'provisionalmarksheetform',
  templateUrl: './provisionalmarksheetform.component.html',
  styleUrls: ['./provisionalmarksheetform.component.scss']
})
export class ProvisionalmarksheetformComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  @ViewChild(DxFormComponent) myform: DxFormComponent;
    private sub: any;
  data:any;
  provisionalmarksheetdata:any;
  provisionalmarksheetdatasource:any;
  isdisable:boolean=true;
  payMode: string[];
  isValid:boolean;
  RequestID:any;
  Fees:number;
  branchdatasource1:any;
  ScheduleList:any;
  courseid:number;
	coursepartid:number;
	branchid:number;
	coursenm:string;
	StudentProvisionalMarksheetID:number;
	Savedisabled: boolean=false;
	ResultQueryTypeID:number;
	ResultQueryCode:number=16;
	resultquerydata:any;
	dataSource: any;
	paymentdis:boolean=true;
	paysource:any;
	paymentmsg:string="";
	printrecdis: boolean=true;
	PaymentFlag:string;
	Canceldisabled: boolean;
	PaydataSource:any;
	ApplicationNO: number;
  classdata: any;
  passingdisable: boolean;
  popupVisible:boolean=false;
  obj: any;
  Documentdata: any;
  showButtons:boolean=true;
  docPath: any[];
  path1: any;
  urlDoc: string;
  popupVisible1: boolean;
  popupTitle: string;
  documentId: any;
  isupload:boolean=false;
  OnLinePaymentConfirmFlag:string;
  ReceiptPrint:any;
  ApplicationReport:any;
  printformdis:boolean=true;
  LanguageLabel:any;
	popupVisiblePayment:boolean=false;
      constructor(private router: Router,private BranchchangeService:BranchchangeService,
        private PhotocopyService:PhotocopyService,private cetService:CetadmissionService,
    private route: ActivatedRoute, private ProvisionalmarksheetService: ProvisionalmarksheetService,private helperService:HelperService, private Configuration: Configuration) {

  }
  cancelClick() {
    this.router.navigate(['/changerequest/provisional-marksheet']);
  }
  PopupShow(){
    this.popupVisible=true;
  }
  PopupClose(){
    this.popupVisible=false;
  }

  ngOnInit() {
    this.LanguageLabel =this.Configuration.LanguageLabel[0];
    this.provisionalmarksheetdata=[];
    this.sub = this.route.queryParams.subscribe(params => {
      let StudentProvisionalMarksheetID = params["StudentProvisionalMarksheetID"];
      this.StudentProvisionalMarksheetID=StudentProvisionalMarksheetID;
      this.RequestID=this.StudentProvisionalMarksheetID;
      this.courseid=params["courseid"];
      this.branchid=params["branchid"];
      this.coursepartid=params["coursepartid"];
      this.coursenm=params["coursenm"];
      this.PaymentFlag=params["PaymentFlag"];
      this.ApplicationNO=params["ApplicationNO"];
      
      });
      if( this.ApplicationNO !=undefined && this.ApplicationNO != null){
        this.ProvisionalmarksheetService.GetDocumentPathForProvisional(this.ApplicationNO,this.Configuration.ExamInstanceID)
        .subscribe((data: provisionalmarksheet[]) => this.docPath = data,
        error => {
          alert(error);
        },
        () => {
          this.path1="";
          if(this.docPath.length>0){
            if(this.docPath[0].DocumentPath!=""&& this.docPath[0].DocumentPath != null && this.docPath[0].DocumentPath != undefined){
              this.path1=this.docPath[0].DocumentPath;
            }
          }
         
      
          this.Documentdata=[];
          this.obj=[];
          this.obj.DocumentName="Document 1";
          this.obj.DocumentPath=this.path1;
          this.obj.ApplicationNO=this.ApplicationNO;
          this.obj.ResultQueryCode=this.ResultQueryCode;
  
          this.Documentdata.push(this.obj);
        });
      }
      else{
        this.path1="";
        this.Documentdata=[];
        this.obj=[];
        this.obj.DocumentName="Document 1";
        this.obj.DocumentPath=this.path1;
        this.obj.ApplicationNO=this.ApplicationNO;
        this.obj.ResultQueryCode=this.ResultQueryCode;

        this.Documentdata.push(this.obj);
      }
     if(this.ApplicationNO==0){
       this.showButtons=false;
     }
      this.PhotocopyService.GetResultQueryByCode(this.ResultQueryCode)
        .subscribe((data: ResultQueryInfo[]) => this.resultquerydata = data,
        error => {
          alert(error);
            },
            () => {
              this.ResultQueryTypeID=this.resultquerydata[0].ResultQueryTypeID
          this.BranchchangeService.CheckScheduleForRequest(this.Configuration.ExamInstanceID,this.courseid,this.ResultQueryTypeID)
          .subscribe((data: BranchChange[]) => this.ScheduleList = data,
          error => {
            alert(error);
          },
          () => { 
            var Schedule =false;
            if(this.ScheduleList ==undefined){
            Schedule=true;
            }
            if(this.ScheduleList.length ==0){
            Schedule=true;
            }
            if(this.ScheduleList[0].ScheduleFlag =="N"){
            Schedule=true;
            }
            
            if(Schedule ==true){
            this.helperService.showWarningMessage("Schedule not defined for this Request");
            this.router.navigate(['/changerequest/provisional-marksheet']);
            return
            }
            else{
              this.BranchchangeService.GetBranchChangeData(this.Configuration.StudentID,this.courseid)
                .subscribe((data:BranchChange[]) => this.provisionalmarksheetdata = data,
                error => {
                alert(error);
                  },
              () => {
                this.provisionalmarksheetdata=this.provisionalmarksheetdata[0];
                this.provisionalmarksheetdata.ApplicationDate=new Date();
                this.provisionalmarksheetdata.ApplicationFees=this.ScheduleList[0].Fees;
                if(this.StudentProvisionalMarksheetID>0){
                  this.Savedisabled=true;
                  this.printformdis=false;
                }
                this.ProvisionalmarksheetService.GetClassIDByStudentID(this.Configuration.StudentID,this.Configuration.ExamInstanceID,this.coursepartid,this.provisionalmarksheetdata.BranchID)
                .subscribe((data:provisionalmarksheet[]) => this.classdata = data,
                  error => {
                     alert(error);
                    },
                  () => {
                  if(this.classdata[0].ClassID!=undefined && this.classdata[0].ClassID!= null)
                    this.provisionalmarksheetdata.ClassID=this.classdata[0].ClassID;
                    this.provisionalmarksheetdata.SeatNO=this.classdata[0].StudentSeatNO;
                  });
               
      }); 
    }
    if(this.PaymentFlag=="Y"){
      this.Canceldisabled=true;
      this.paymentdis=true;
      this.Savedisabled=true;
      this.printformdis=false;
    }
    if(this.OnLinePaymentConfirmFlag=="Y"){
      this.printrecdis=false;
    }
    if(this.PaymentFlag=="N" && this.StudentProvisionalMarksheetID>0){
      this.Canceldisabled=false;
      this.paymentdis=false;
      this.printrecdis=true;
      this.Savedisabled=true;
      this.printformdis=false;
    }	
    if(this.PaymentFlag=="N" && this.StudentProvisionalMarksheetID==0){
      this.Canceldisabled=true;
      this.paymentdis=true;
      this.printrecdis=true;
      this.Savedisabled=false;
    }
  });
});

   
  }
 
  CancelApplication(){
   
    this.ProvisionalmarksheetService.CancelProvisionalMarksheet( this.RequestID,this.provisionalmarksheetdata.StudentID,this.Configuration.AcademicInstanceID,this.ResultQueryCode)
    .subscribe((data: provisionalmarksheet[]) => this.dataSource = data,
    error => {
      alert(error);
    },
    () => {
        this.helperService.showSuccessMessage("Your Application Cancelled sucessfully"); 
        this.paymentdis=true;
      
        this.router.navigate(['/changerequest/provisional-marksheet']);
      }); 
  

  }
  save(){

   this.Savedisabled=true;
    this.provisionalmarksheetdata.CreatedLoginID=this.Configuration.CreatedLoginID;
    this.provisionalmarksheetdata.UpdatedLoginID=this.Configuration.UpdatedLoginID;
    this.provisionalmarksheetdata.DeleteFlag = "N";
    this.provisionalmarksheetdata.ApplicationDate=formatDate(new Date(), 'dd/MMM/yyyy hh:mm:ss', 'en');
    this.provisionalmarksheetdata.ExamInstanceID=this.Configuration.ExamInstanceID;
    this.provisionalmarksheetdata.CollegeID=this.provisionalmarksheetdata.StudentCollegeID;
    this.provisionalmarksheetdata.AcademicInstanceID=this.Configuration.AcademicInstanceID;
    this.provisionalmarksheetdata.ResultQueryTypeID=this.ResultQueryTypeID;


    this.ProvisionalmarksheetService.save(this.provisionalmarksheetdata)
    .subscribe(value => {
      this.onSuccessSave();
      this.RequestID= value;
      if(this.provisionalmarksheetdata.ApplicationFees>0){
        this.popupVisiblePayment=true;
      }
    },
      err => {
        this.Savedisabled=false;
    //		this.errorMessage=this.helperService.getErrorMessage(err);
      },
      () => {
      
      });
  
  }
  onSuccessSave() {
    this.helperService.showSuccessMessage("Provisional Marksheet Application Saved");
    if(this.provisionalmarksheetdata.ApplicationFees==0){
      this.router.navigate(['/changerequest/provisional-marksheet']);
    }
  }
  PrintForm(){
		this.BranchchangeService.GetApplicationFormPrintForCertificates(this.Configuration.StudentID,this.RequestID,this.Configuration.ExamInstanceID,this.ResultQueryCode)
		.subscribe((data:BranchChange[]) => this.ApplicationReport = data,
		error => {
		alert(error);
		  },
		  () => {
		   if(this.ApplicationReport.Message!=""&&this.ApplicationReport.IsSuccess!=false){
			  window.open(this.ApplicationReport.Message,'_blank');
			}
		   
		  });
	  }
  GetPaymentTrxNo()
  {
   this.Canceldisabled=true;
    ;
    this.provisionalmarksheetdata.PurposeCode=this.Configuration.PurposeCodeRequest;
    if(this.provisionalmarksheetdata.PaymentType =="O"){
      this.provisionalmarksheetdata.payModeID=1;
    }else{
      this.provisionalmarksheetdata.payModeID=0;
    }
    
      if(this.provisionalmarksheetdata.PaymentType==undefined|| this.provisionalmarksheetdata.PaymentType==null){
        this.provisionalmarksheetdata.PaymentType="O";
      }
    this.provisionalmarksheetdata.ExamInstanceID=this.Configuration.ExamInstanceID;
    if(this.provisionalmarksheetdata.PaymentType =="O") {
        this.paymentdis=true;
        this.cetService.getPaymentTrxNo(this.provisionalmarksheetdata.StudentID, this.provisionalmarksheetdata.CourseID, this.provisionalmarksheetdata.CoursePartID, this.provisionalmarksheetdata.BranchID, this.Configuration.AcademicInstanceID,  this.Configuration.ExamInstanceID, this.provisionalmarksheetdata.PurposeCode, this.provisionalmarksheetdata.ApplicationFees, 0,this.provisionalmarksheetdata.StudentCollegeID)
        .subscribe((data: CETadmission[]) => this.dataSource = data,
        error => {
          alert(error);
        },
        () => {
          ;
          if (this.dataSource[0].merchantTxnNo !=undefined || this.dataSource[0].merchantTxnNo != null)
          {
            this.provisionalmarksheetdata.customerName = this.dataSource[0].customerName;
            this.provisionalmarksheetdata.customerEmailId = this.dataSource[0].customerEmailId;
            this.provisionalmarksheetdata.customerMobileNo = this.dataSource[0].customerMobileNo; 
            this.provisionalmarksheetdata.customerID = this.dataSource[0].OnlinePaymentID;                       
            this.provisionalmarksheetdata.merchantTxnNo = this.dataSource[0].merchantTxnNo;


            this.openWindowWithPostRequest();
          }
        });
    }
  }
  openWindowWithPostRequest() { 
    ;
    var winName = 'MyWindow';
    var winURL = this.Configuration.PaymentAPIURL;
    var windowoption = 'resizable=yes,height=600,width=800,location=0,menubar=0,scrollbars=1';    
   
    var params = { 'StudentID': this.Configuration.StudentID, 'CourseID':  this.provisionalmarksheetdata.CourseID, 
    'BranchID': this.provisionalmarksheetdata.BranchID, 'AcadamicInstanceID': this.Configuration.AcademicInstanceID, 
    'PurposeCode': this.provisionalmarksheetdata.PurposeCode,'FeesAmount': this.provisionalmarksheetdata.ApplicationFees,
    'merchantTxnNo': this.provisionalmarksheetdata.merchantTxnNo, 'customerName': this.provisionalmarksheetdata.customerName,
    'customerEmailId': this.provisionalmarksheetdata.customerEmailId, 'customerMobileNo': this.provisionalmarksheetdata.customerMobileNo,
    'customerID': this.provisionalmarksheetdata.customerID, };
    var form = document.createElement("form");
    form.setAttribute("method", "post");
    form.setAttribute("action", winURL);
    form.setAttribute("target", winName);
    for (var i in params) {
        if (params.hasOwnProperty(i)) {
            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = i;
            input.value = params[i];
            form.appendChild(input);
        }
    }
    document.body.appendChild(form);
    window.open('', winName, windowoption);
    form.target = winName;
    form.submit();
    document.body.removeChild(form);
    this.onSubmit();
}

  timeLeft: number = 50;
  interval;

  onSubmit() {
    this.paymentmsg="Your Payment Transaction in Process please wait...";
    this.interval = setInterval(() => {
      if(this.timeLeft > 0) {
        this.timeLeft --;
        
        this.cetService.GetPaymentTranDetails( this.provisionalmarksheetdata.merchantTxnNo) 
        .subscribe((data:CETadmission[]) => this.paysource = data,
        error => {
        alert(error);
          },
          () => {
            
                  if(this.paysource.length ==0){
                    this.paymentdis =false;
              
                    return;
                  }
                  if (this.paysource[0].responseCode != undefined || this.paysource[0].responseCode != null)
                  {

                 
                      if(this.paysource[0].OnlinePaymentConfirmFlag =="Y")
                      {           
                                                              
                        this.ProvisionalmarksheetService.GetUpdatePaymentStatusForProvisionalMarksheet(this.provisionalmarksheetdata.merchantTxnNo,this.Configuration.ExamInstanceID, this.ApplicationNO,this.Configuration.StudentID)
                        .subscribe((data: provisionalmarksheet[]) => this.PaydataSource = data,
                        error => {
                          alert(error);
                        },
                        () => {
                          this.provisionalmarksheetdata.ApplicationFees=this.paysource[0].amount;
                          this.paymentdis =true;
                          this.helperService.showSuccessMessage("Your Payment Transaction is successful, your Transcation Number is " + this.paysource[0].merchantTxnNo);  
                          this.router.navigate(['/changerequest/provisional-marksheet']);
                          this.printrecdis=false;
                        });
                        
                      }
                      else
                      {
                            this.provisionalmarksheetdata.ApplicationFees=this.paysource[0].amount;
                            this.paymentdis =false;
                            this.helperService.showWarningMessage("Your Payment Transaction is failure, your Transcation Number is " + this.paysource[0].merchantTxnNo  + " try again...");
                            this.Canceldisabled=false;
                      }
                      this.pauseTimer();
                }
                else
                {
                  this.paymentmsg="Your Payment Transaction in Process...";
                }
                  
          });  


      } else {
        this.pauseTimer();
        this.paymentmsg="Transaction is time out please try again...";
      }
    },10000)
  }

  pauseTimer() {
    clearInterval(this.interval);
  }
  PrintReceipt(){
		this.BranchchangeService.GetRequestPaymentReceipt(this.ResultQueryTypeID,this.ApplicationNO,this.Configuration.ExamInstanceID)
		.subscribe((data:BranchChange[]) => this.ReceiptPrint = data,
		error => {
		alert(error);
		  },
		  () => {
		   if(this.ReceiptPrint.Message!=""&&this.ReceiptPrint.IsSuccess!=false){
			  window.open(this.ReceiptPrint.Message,'_blank');
			}
		   
		  });
	  }
  viewPdfDocument(data) {
    var path=data.key.DocumentPath;
     window.open(path,"_blank"); 
   }
   ConfirmOKPayment(){
    this.popupVisiblePayment =false;
    this.BranchchangeService.GetPostInsertReceiptPaymentsForAdmission(this.provisionalmarksheetdata.StudentID,this.Configuration.AcademicInstanceID,this.provisionalmarksheetdata.ApplicationFees,this.provisionalmarksheetdata.CourseID,this.provisionalmarksheetdata.CoursePartID,this.provisionalmarksheetdata.BranchID,this.Configuration.ExamInstanceID,this.ResultQueryCode,this.RequestID)
		.subscribe((data:BranchChange[]) => this.ApplicationReport = data,
		error => {
		alert(error);
		  },
		  () => {
        this.router.navigate(['/changerequest/provisional-marksheet']);
        this.popupVisiblePayment =false;
		  });
    }
    onCloseButtonPayment(e) {
      this.popupVisiblePayment =false;
      this.router.navigate(['/changerequest/provisional-marksheet']);
    };
}







